import React, {useEffect, useState} from "react";
import "./Button.css";

let Button = (props) => {
    let [typeClasses, setTypeClasses] = useState('Button');
    let [sizeClasses, setSizeClasses] = useState('Button--m');

    useEffect(()=>{
        switch (props.type) {
            case "secondary":
                setTypeClasses("Button--secondary");
                break
            default:
                setTypeClasses("Button");
                break
        }
    }, [props.type])

    useEffect(()=>{
        switch (props.size) {
            case "m":
                setSizeClasses("Button--m");
                break
            case "l":
                setSizeClasses("Button--l");
                break
            case "xl":
                setSizeClasses("Button--xl");
                break
            default:
                setSizeClasses("Button--m");
                break
        }
    }, [props.size])


    return(
        <div {...props} className={typeClasses+" "+sizeClasses}>
            {props.before ? <div className="Button--before">
                {props.before}
            </div> : false}
            <div className="Button--content">
                {props.children}
            </div>
        </div>
    );
}
export default Button;